//Angular components
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

//App components
import { SharedGlobalService } from 'src/app/_core/services/api';
import { AuthService } from 'src/app/_core/services/auth.service';
import { RestResponse, Role, User, UserCompany } from 'src/app/_shared/models';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { DataSharingService, StorageService } from 'src/app/_core/services';

//Rebillia's library
import { MoodBasic } from '@rhinosaas/reb-ngx/reb-ngx-shared/tokens/palette';
import { map, startWith } from 'rxjs';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-user-company',
  templateUrl: './user-company.component.html',
  styleUrls: ['./user-company.component.scss']
})
export class UserCompanyComponent implements OnInit, OnDestroy {

  form: FormGroup;
  private subs = new Unsubscriber();
  disableButton: boolean = true;
  selectedUserCompany: UserCompany;
  message: string = "There was a problem with when trying to list your companies.";
  moodMessage: MoodBasic = 'warning';
  filteredCollectionOfUserCompany : Array<UserCompany> = [];

  @Output() companyData: EventEmitter<any> = new EventEmitter<any>();
  @Input() hasMessage: boolean = false;


  _collectionOfUserCompany: Array<UserCompany>;
  @Input('collectionOfUserCompany') set collectionOfUserCompany(value: Array<UserCompany>) {
      this._collectionOfUserCompany = [...value];
      this.filteredCollectionOfUserCompany = [...value]
  }
  get collectionOfUserCompany(): Array<UserCompany> {
      return this._collectionOfUserCompany;
  }

  constructor(
    private auth: AuthService,
    private dataService: DataSharingService,
    private fb: FormBuilder,
    private router: Router,
    private sharedGlobalService: SharedGlobalService,
    private storage: StorageService,
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    if(this.collectionOfUserCompany.length > 0) {
      this.setUpForm();
    }
  }

  setUpForm() {
    const valueSelected = this.collectionOfUserCompany.length > 1 ? null :this.collectionOfUserCompany[0];
    this.form = this.fb.group({
      company: [{value: valueSelected, disabled:false}]
    });
    this.registerFilter();

    if(valueSelected){
      const value = { option: { value: valueSelected} };
      this.onSelectCompany(value);
    }

  }

  registerFilter(){
    this.form.get('company').valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.collectionOfUserCompany.slice();
      }),
    ).subscribe((filtered=>{
      this.filteredCollectionOfUserCompany = filtered;
      this.resetButton();
    }))
  }

  resetButton(){
    this.selectedUserCompany = null;
    this.disableButton = true;
  }

  private _filter(name: string): UserCompany[] {
    const filterValue = name.toLowerCase();

    return this.collectionOfUserCompany.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  displayFn(company){
    return company?.name
  }

  onSelectCompany($event) {
    this.selectedUserCompany = <UserCompany> $event?.option?.value;
    this.disableButton = false;
  }

  createLogs(_id: any) {
    this.subs.addSub = this.sharedGlobalService.createLogs(_id, { 'code': 'user_login' }).subscribe(
      (res: RestResponse) => {
      },
      (err: RestResponse) => {
        console.log(err);
      }
    )
  }

  navigateToDashboard() {
    this.dataService.setCompany({ companyId: this.selectedUserCompany.id, companyName: this.selectedUserCompany.name });
    this.storage.writeLocalStorage('entityId', this.selectedUserCompany.id);
    this.storage.writeLocalStorage('entityName', this.selectedUserCompany.name);
    this.storage.writeLocalStorage('supportPin', this.selectedUserCompany.supportPin);
    this.storage.writeLocalStorage('status', this.selectedUserCompany.status);
    this.storage.writeLocalStorage('userRole', this.selectedUserCompany.role.toLowerCase());
    this.storage.writeLocalStorage('cancelledAt', this.selectedUserCompany.cancelledAt);

    this.router.navigate(["/main/dashboard"]);
  }

  onLogout() {
    this.auth.logout();
  }

}
